import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    container: 'pointer-events-auto fixed inset-x-0 bottom-0 z-50 flex flex-col',
    handle: 'flex h-6 cursor-grab items-center justify-center active:cursor-grabbing',
    handleBar: 'bg-disabled h-1.5 w-12 rounded-full',
    content: 'bg-color-base flex-1 overflow-y-auto rounded-t-2xl shadow-lg'
  }
});
